import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "indicator", "counter"]
  static values = {
    index: { type: Number, default: 0 },
    autoplay: { type: Boolean, default: false },
    interval: { type: Number, default: 5000 }
  }

  connect() {
    console.log('Image carousel connected')
    this.showSlide(this.indexValue)
    if (this.autoplayValue) {
      this.startAutoplay()
    }
    
    // Add touch event listeners for swipe functionality
    this.touchStartX = 0
    this.touchEndX = 0
    this.handleTouchStartBound = this.handleTouchStart.bind(this)
    this.handleTouchEndBound = this.handleTouchEnd.bind(this)
    this.element.addEventListener('touchstart', this.handleTouchStartBound, { passive: true })
    this.element.addEventListener('touchend', this.handleTouchEndBound, { passive: true })
  }

  disconnect() {
    this.stopAutoplay()
    this.element.removeEventListener('touchstart', this.handleTouchStartBound)
    this.element.removeEventListener('touchend', this.handleTouchEndBound)
  }

  handleTouchStart(event) {
    this.touchStartX = event.changedTouches[0].screenX
    console.log('Touch start:', this.touchStartX)
  }

  handleTouchEnd(event) {
    this.touchEndX = event.changedTouches[0].screenX
    console.log('Touch end:', this.touchEndX)
    this.handleSwipe()
  }

  handleSwipe() {
    const swipeThreshold = 50 // minimum distance for a swipe
    const diff = this.touchStartX - this.touchEndX

    console.log('Swipe diff:', diff)
    
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swiped left - go to next slide
        console.log('Swiping to next')
        this.next()
      } else {
        // Swiped right - go to previous slide
        console.log('Swiping to previous')
        this.previous()
      }
    }
  }

  next() {
    this.stopAutoplay()
    this.indexValue = (this.indexValue + 1) % this.slideTargets.length
    this.showSlide(this.indexValue)
  }

  previous() {
    this.stopAutoplay()
    this.indexValue = (this.indexValue - 1 + this.slideTargets.length) % this.slideTargets.length
    this.showSlide(this.indexValue)
  }

  goToSlide(event) {
    this.stopAutoplay()
    this.indexValue = parseInt(event.currentTarget.dataset.index)
    this.showSlide(this.indexValue)
  }

  showSlide(index) {
    this.slideTargets.forEach((slide, i) => {
      if (i === index) {
        slide.classList.remove("hidden")
        slide.classList.add("animate-fade-in")
      } else {
        slide.classList.add("hidden")
      }
    })

    if (this.hasIndicatorTarget) {
      this.indicatorTargets.forEach((indicator, i) => {
        if (i === index) {
          indicator.classList.remove("bg-white/30")
          indicator.classList.add("bg-emerald-600")
        } else {
          indicator.classList.remove("bg-emerald-600")
          indicator.classList.add("bg-white/30")
        }
      })
    }

    // Update counter if it exists
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = index + 1
    }
  }

  startAutoplay() {
    this.autoplayTimer = setInterval(() => {
      this.indexValue = (this.indexValue + 1) % this.slideTargets.length
      this.showSlide(this.indexValue)
    }, this.intervalValue)
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer)
    }
  }
}
